/**
 * V3: iFrame Observer
 *
 * - Marks iframes without a title as aria-hidden for WCAG AA compliance
 *
 * @module components/iFrameObserver
 */

const observer = new MutationObserver((mutations) =>
{
	for (const mutation of mutations)
	{
		for (const node of mutation.addedNodes)
		{
			if (node.nodeName === 'IFRAME' && !node.title)
			{
				node.setAttribute('aria-hidden', 'true');
			}
		}
	}
});

document.addEventListener('DOMContentLoaded', () =>
{
	observer.observe(document.body, { childList: true, subtree: true });
});
